import { Box, Link, Typography } from '@mui/material';
import { ActionItemStatus, ProviderActivationEventName } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { LightChip } from '@uplift/ui-v2';

import { getChipColor, hasEvent } from '../../helpers';
import { SelectStatesModal } from '../../pages';
import { useSharedStyles } from '../../styles';
import { useProviderActivationEvents, useProviderLicensesStatusQuery } from '@uplift/queries';
import { useCurrentuser } from '@uplift/contexts';

export type CredentialingProps = {
  status: ActionItemStatus;
  isSelectStatesModalOpen: boolean;
  setIsSelectStatesModalOpen: (show: boolean) => void;
  handleCloseModal: () => void;
};

export const Credentialing: React.VFC<CredentialingProps> = ({ status, isSelectStatesModalOpen, setIsSelectStatesModalOpen, handleCloseModal }) => {
  const l10n = useL10n();
  const { classes: sharedClasses } = useSharedStyles();
  const me = useCurrentuser();
  const { data: events } = useProviderActivationEvents(me?.id);
  const { data: licenses, isLoading } = useProviderLicensesStatusQuery(me?.id);
  const isStateSelectionSubmitted = hasEvent(events, ProviderActivationEventName.stateSelectionSubmitted);
  const liveStates = licenses?.filter(license => license.live).map(license => license.stateId) || [];


  const handleLinkClick = () => {
    setIsSelectStatesModalOpen(true);
  };

  if (status === ActionItemStatus.todo || isLoading) {
    return null;
  }

  return (
    <Box className={sharedClasses.progressSummaryStepWithChip}>
      {isSelectStatesModalOpen && <SelectStatesModal closeModal={handleCloseModal} />}
      <Box display="flex" flexDirection="column">
        <Typography variant="h5">{l10n.providerSettings.onboarding.credentialing}</Typography>
        {isStateSelectionSubmitted && licenses.length > 1 && liveStates.length > 0 && (
          <Link onClick={handleLinkClick} className={sharedClasses.link}>Edit Selected States</Link>
        )}
      </Box>
      <LightChip label={l10n.dashboard.actionItems.status[status]} color={getChipColor(status)} size="small" />
    </Box>
  );
};
